import React from 'react';
import CheckIcon from '@tradera/blueprint/theme/icons2/check.svg?jsx';
import MultiColorImage from '@tradera/blueprint/theme/icons-colored/multicolor.svg';
import { useTranslator } from 'tradera-lang/translate';
import './attribute-color.scss';
import { getTranslatedAttributeValue } from 'tradera-components/attributes/attribute-helper';

const multiColorStyle = {
    backgroundImage: `url(${MultiColorImage})`
};

const getStyle = value => (value === 'multi' ? multiColorStyle : null);

const AttributeColor = ({
    attribute,
    hideAttribute,
    handleClick,
    selected,
    isDisabled = false,
    size = 'xs',
    className = ''
}) => {
    const { t } = useTranslator();
    attribute.value = attribute.value.toLowerCase();
    const attributeValue = getTranslatedAttributeValue(
        'af-color',
        attribute.value,
        t
    );
    return (
        <button
            type="button"
            className={`btn btn-${size} btn-outline-dark mb-1 mr-1 position-relative ${
                hideAttribute ? 'd-none' : 'd-inline-block'
            } ${isDisabled ? 'cursor-not-allowed' : ''} ${className}`}
            onClick={() => {
                handleClick();
            }}
            aria-label={attributeValue}
            title={attributeValue}>
            <span
                className={`attribute-filter__color ${attribute.value}`}
                style={getStyle(attribute.value)}>
                {selected && (
                    <div className="color-selected">
                        <CheckIcon className="icon icon-dark" />
                    </div>
                )}
            </span>
            <span className="pr-0 pl-4">{attributeValue}</span>
        </button>
    );
};

export default AttributeColor;
